import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      display: "flex",
      paddingLeft: theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      })
    }
  };
});
export default useStyles;